import {createApp} from 'vue'
import SourceReferences from './SourceReferences'

const el = '.kb-component--source-references'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((SourceReferencesDOM)=>{
            const props = {
                sourceId: SourceReferencesDOM.dataset.sourceId,
            }
            const component = createApp(SourceReferences, props).use(Store)
            component.mount(SourceReferencesDOM)
        })
    }
}